const audiences = [
  {
    icon: "ri-seedling-line",
    title: "Aspiring Traders",
    desc: "Individuals who are curious about futures markets and want a structured, beginner-friendly entry point into trading education.",
    tag: "Beginner Welcome",
  },
  {
    icon: "ri-briefcase-line",
    title: "Young Professionals",
    desc: "Career-driven professionals looking to build financial literacy alongside their careers and create a stronger personal wealth foundation.",
    tag: "Career-Focused",
  },
  {
    icon: "ri-global-line",
    title: "Diaspora Investors",
    desc: "African Diaspora members seeking structured education to better understand global markets and cross-border investment opportunities.",
    tag: "Diaspora-Centered",
  },
  {
    icon: "ri-road-map-line",
    title: "Beginners Seeking Structure",
    desc: "Those who have tried to learn on their own but want a guided, disciplined pathway with real support and community.",
    tag: "Guided Learning",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "Existing Investors",
    desc: "Investors with some experience who want to deepen their market knowledge, improve decision-making, and diversify their financial education.",
    tag: "Knowledge Deepening",
  },
];

export default function WhoItsFor() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-4">
            <span className="w-8 h-px bg-[#C9A961]" />
            Who It&apos;s For
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] mb-4">
            Built for Serious Learners at Every Stage
          </h2>
          <p className="text-[#6B6B6B] text-base max-w-2xl mx-auto font-light leading-relaxed">
            The Harambee Trading Academy welcomes learners from all backgrounds. Whether you are starting from zero or building on existing knowledge, there is a pathway designed for you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {audiences.map((item, i) => (
            <div
              key={item.title}
              className={`bg-white rounded-lg p-8 border border-[#E8E4DC] hover:border-[#C9A961]/40 transition-all duration-300 group ${i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}`}
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 group-hover:bg-[#1A4D3C]/20 transition-colors">
                  <i className={`${item.icon} text-[#1A4D3C] text-xl`} />
                </div>
                <span className="text-[10px] font-semibold uppercase tracking-widest text-[#C9A961] bg-[#C9A961]/10 px-3 py-1 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-3">{item.title}</h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
